import {
  Box,
  HStack,
  Text,
  Button,
  IconButton,
  useColorModeValue,
  Badge,
  Avatar,
  VStack,
  Wrap,
  WrapItem,
  Tooltip,
} from '@chakra-ui/react';
import { FiUserPlus } from 'react-icons/fi';

interface Member {
  id: string;
  name: string;
  email: string;
  photoURL?: string;
}

interface ChatHeaderProps {
  conversationName: string;
  isGroupChat: boolean;
  memberCount?: number;
  members?: Member[];
  onAddMembers?: () => void;
}

export function ChatHeader({
  conversationName,
  isGroupChat,
  memberCount,
  members,
  onAddMembers,
}: ChatHeaderProps) {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const memberBgColor = useColorModeValue('gray.50', 'gray.700');
  const memberTextColor = useColorModeValue('gray.700', 'gray.300');

  return (
    <Box
      bg={bgColor}
      borderBottomWidth="1px"
      borderColor={borderColor}
      px={4}
      py={3}
    >
      <VStack spacing={2} align="stretch">
        <HStack justify="space-between" align="center">
          <HStack spacing={3} flex="1" minW={0}>
            <Text fontSize="md" fontWeight="semibold" isTruncated>
              {conversationName}
            </Text>
            {isGroupChat && memberCount !== undefined && (
              <Badge colorScheme="gray" fontSize="xs">
                {memberCount} members
              </Badge>
            )}
          </HStack>
          {isGroupChat && onAddMembers && (
            <IconButton
              aria-label="Add members"
              icon={<FiUserPlus />}
              size="sm"
              variant="ghost"
              onClick={onAddMembers}
            />
          )}
        </HStack>
        
        {/* Member List */}
        {isGroupChat && members && members.length > 0 && (
          <Box>
            <Wrap spacing={2}>
              {members.map((member) => (
                <WrapItem key={member.id}>
                  <Tooltip label={member.name} placement="top">
                    <HStack spacing={2} px={2} py={1} borderRadius="md" bg={memberBgColor}>
                      <Avatar
                        size="xs"
                        src={member.photoURL}
                        name={member.name}
                      />
                      <Text fontSize="xs" color={memberTextColor}>
                        {member.name}
                      </Text>
                    </HStack>
                  </Tooltip>
                </WrapItem>
              ))}
            </Wrap>
          </Box>
        )}
      </VStack>
    </Box>
  );
}

